import {DateUtil} from './date_util.js'
import {product} from '@/components/sonjiandan/productNameCache.js'
import dictCache from '@/components/dict/dictCache.js'
import {parserXlsx} from '@/components/excel/excelParser.js'

var util = {
  transformValueForExport: function (data) {//将数据值转成导出时需要的
    let data_ = [];
    data.forEach(d => {
      let d_ = {...d};
      //产品名称
      if (d_.hasOwnProperty('productNo')) {
        d_.productName = product.getProductNameByProductNo(d_.productNo);
      }
      //是否为历史样本
      if (d_.hasOwnProperty('sampleHistory')) {
        d_.sampleHistory = dictCache.getDictLableValue('sys_yes_no', d_.sampleHistory);
      }
      //是否备份管
      if (d_.hasOwnProperty('isBackup')) {
        d_.isBackup = dictCache.getDictLableValue('sys_yes_no', d_.isBackup);
      }
      //是否需要质控
      if (d_.hasOwnProperty('isQa')) {
        d_.isQa = dictCache.getDictLableValue('sys_yes_no', d_.isQa);
      }
      //是否进行试验
      if (d_.hasOwnProperty('isOmics')) {
        d_.isOmics = dictCache.getDictLableValue('sys_yes_no', d_.isOmics);
      }
      //单位
      if (d_.hasOwnProperty('sampleQuantityUnit')) {
        d_.sampleQuantityUnit = dictCache.getDictLableValue('unit', d_.sampleQuantityUnit);
      }
      //合并/拆分
      if (d_.hasOwnProperty('joinSplit')) {
        d_.joinSplit = dictCache.getDictLableValue('sample_split_type', d_.joinSplit);
      }
      data_.push(d_)
    })
    return data_;
  },
  exportDataFunc(columns_, data, type = 1, fileName='导出数据') {//data为转化过的数据
    //按表头顺序对应数据
    let exportData = [];
    let head = [];
    for (var i = 0; i < columns_.length; i++) {
      let title_ = columns_[i].columnTitle || columns_[i].title;
      if (title_ != '操作' && title_ != '编号') {
        head.push(title_);
      }
    }
    exportData.push(head);
    data.forEach(d => {
      let row = [];
      columns_.forEach(c => {
        if ((c.columnTitle || c.title) != '操作' && (c.columnTitle || c.title) != '编号') {
          let v = d[c.dataIndex];
          if ((c.columnTitle || c.title) == '产品名称') {
            v = d['productName'];
          }
          row.push(v);
        }
      })
      exportData.push(row);
    });
    if (type == 1) {
      parserXlsx.exportXls(exportData);
    }else if(type == 3) {
      parserXlsx.exportOther(exportData, fileName);
    } else {
      parserXlsx.exportCybjfaXls(exportData);
    }
    // console.log(exportData);

  },
  attachProductName: function (data) {//加上产品名称字段
    data.forEach(d => {
      if (d.productNo) {
        d.productName = product.getProductNameByProductNo(d.productNo);
      }
    })
  },
  transformFields: function (values) {
    for (var key in values) {
      var vals = values[key];
      if (vals && vals._isAMomentObject) {//转换日期格式
        values[key] = DateUtil.formatDateToStr(new Date(vals._d));
      }
      if (typeof (vals) != 'boolean' && typeof (vals) != 'number' && !vals) {//不是boolean又不存在
        values[key] = '';
      }
      if (typeof (vals) == 'boolean') {//转换boolean至int
        values[key] = vals ? 0 : 1;
      }
    }
    //console.log(values)
    return values;
  },
  attachIndexNumForList: function (data) {//给列表添加序号
    if (!data) {
      return;
    }
    var i = 0;
    data.forEach(d => {
      d.key = ++i;
    });
  },
  transformFormData: (params) => {//转换成formdata
    var formParams = new FormData();
    for (var k in params) {
      let p = params[k];
      p = !p ? '' : p;
      formParams.append(k, p);
    }
    return formParams;
  },
  transformRefDataDisplay: function (vo) {//转换引用字典显示中文
    for (var i = 0; i < vo.dataSource.length; i++) {
      for (var j = 0; j < vo.columns.length; j++) {
        if (vo.columns[j].refData) {
          let key = vo.columns[j].dataIndex;
          vo.refDataSource[vo.columns[j].refData].forEach(function (d) {
            if (d.code == vo.dataSource[i][key]) {
              vo.dataSource[i][key] = d.value;
            }
          })
        }
      }
    }
  },
  initOrgTreeData: function (orgs) {//机构树
    var orgTree = [];
    if (orgs.length > 0) {
      for (var i in orgs) {
        let m = orgs[i];
        var tree_node = {id: m.deptId, title: m.deptName, key: m.deptId, value: m.deptId, slots: {icon: 'tag'}};
        orgTree.push(tree_node);
        if (m.children && m.children.length > 0) {
          tree_node.slots = {icon: 'folder'};
          tree_node.children = [];
          this.getOrgTree(tree_node.children, m.children);
        }
      }
    }
    return orgTree;
  },
  getOrgTree: function (tree_children, mene_children) {
    for (var i in mene_children) {
      let m = mene_children[i];
      var tree_node = {id: m.deptId, title: m.deptName, key: m.deptId, value: m.deptId, slots: {icon: 'tag'}};
      tree_children.push(tree_node);
      if (m.children && m.children.length > 0) {
        tree_node.slots = {icon: 'folder'};
        tree_node.children = [];
        this.getOrgTree(tree_node.children, m.children);
      }
    }
  },
  initKnowledgeTreeData: function (orgs) { // 知识库树
    var orgTree = [];
    if (orgs.length > 0) {
      for (var i in orgs) {
        let m = orgs[i];
        var tree_node = {
          id: m.saleTypeId,
          title: m.saleTypeName,
          key: m.saleTypeId,
          value: m.saleTypeId,
          slots: {icon: 'tag'},
          scopedSlots: {"title": "custom"}
        };
        orgTree.push(tree_node);
        if (m.childList && m.childList.length > 0) {
          tree_node.slots = {icon: 'folder'};
          tree_node.children = [];
          this.getKnowledgeTree(tree_node.children, m.childList);
        }
      }
    }
    return orgTree;
  },
  getKnowledgeTree: function (tree_children, mene_children) {
    for (var i in mene_children) {
      let m = mene_children[i];
      var tree_node = {
        id: m.saleTypeId,
        title: m.saleTypeName,
        key: m.saleTypeId,
        value: m.saleTypeId,
        slots: {icon: 'tag'},
        scopedSlots: {"title": "custom"}
      };
      tree_children.push(tree_node);
      if (m.childList && m.childList.length > 0) {
        tree_node.slots = {icon: 'folder'};
        tree_node.children = [];
        this.getKnowledgeTree(tree_node.children, m.childList);
      }
    }
  },
  displayFormItem: function (formColumns, item, dataSource) {
    formColumns.forEach(col => {
      let column = col.column;
      item[column] = dataSource[column];
      if (col.isTranf) {
        let tempValue = item[column];
        if (!tempValue) {
          item[column] = [];
          return;
        }
        if (tempValue.indexOf(',') > -1) {
          item[column] = tempValue.split(',');
        } else {
          item[column] = [tempValue];
        }
      }
    })
  },
  isDeliveryApplyRequiredMsg(msg) {
    return !!msg && String(msg).indexOf("请填写交付申请") > -1;
  },
}
export {util}



// WEBPACK FOOTER //
// ./src/components/utils/util.js